import React, {Component} from 'react';
import {Image} from 'react-bootstrap';
import Masonry from 'react-masonry-component';
import './style.css';


const masonryOptions = {
    transitionDuration: 0
};

class DesignResourcesPanel extends Component {

    constructor(props) {
        super(props);
        this.state = {
            base_id: Math.floor(Math.random() * 10000000000)
        };
    }

    get_src_from_resource = resource => {
        var tail = ''
        if(this.props.noCache){
            tail = '?t='+Date.now()
        }
        var src = resource.thumbnail ? resource.thumbnail : (resource.low_src?resource.low_src:resource.src)
        if(!src){
            return '';
        }
        if (src.indexOf('data:image')>-1 || src.indexOf('http')>-1 || src.indexOf('blob:')>-1) {
            if(src.indexOf('blob:')>-1 || src.indexOf('data:image')>-1){
                return src;  
            }else{
                return global.config.server_path.replace('api/','')+'api/image_proxy?src='+window.encodeURIComponent(src)
            }
        } else {
            return global.config.server_path + src + tail;
        }
    }

    MyLoader = props => (
        <div style={{backgroundColor:'#f1f2f3',width: props.width ? props.width : '100%', height: props.height ? props.height : '100%'}}>
        </div>
    )

    free_annotation = () => (
        <div className="annotation">FREE</div>);
    
    premium_annotation = () => (
        <div className="annotation big">{this.props.annotation_text || "PREMIUM ($1)"}</div>
    );

    DesignResourceThumbnails = () => {
        var results_card = []
        var resource_generate_temp = function(i,this_as_param,height){
            var x = this_as_param.props.noCache ? {height} : {};
            return (
                <li key={'design_rsc_thumbnail'+i} 
                    style={{'width' : this_as_param.props.image_height,marginTop:'5px',marginBottom: this_as_param.props.noCache ? 38 : '5px', 'marginRight': this_as_param.props.margin_right||'5px','marginLeft': this_as_param.props.margin_left||'5px', 'padding': '0',boxShadow: '0 0 8px 0 rgba(66,66,66,0.5)',borderRadius:'6px', ...x}}
                    className="saved-design-thumbnails"
                >
                    {this_as_param.props.showContextMenu?(() => this_as_param.props.contextMenu(this_as_param.props.resources[i]))():''}
                    
                    <div id={this_as_param.state.base_id + i}  style={{zIndex: '-100', display: 'block', width: '100%', height, position: this_as_param.props.noCache ? 'absolute' : 'realtive'}}><this_as_param.MyLoader height={height}/></div>

                    <div className="design_resource_thumbnail">
                    {(this_as_param.props.annotate && this_as_param.props.resources[i].free)?this_as_param.free_annotation():(this_as_param.props.annotate?this_as_param.premium_annotation():"")}
                    <Image 
                        className = "unselectable"
                        onLoad = {(e) => {
                            if(!this_as_param.props.noCache) {
                                window.document.getElementById(this_as_param.state.base_id + i).style.display = 'none';
                                e.target.style.display = 'block';
                            }
                        }}
                        onDragStart={(e) => {this_as_param.props.on_drag_start(this_as_param.props.resources[i],e)}} 
                        onDrag={(e) => {if(this_as_param.props.on_drag){this_as_param.props.on_drag(this_as_param.props.resources[i],e)}}} 
                        onDragEnd={(e) => {this_as_param.props.on_drag_end(this_as_param.props.resources[i],e)}} 
                        onClick={(e) => {this_as_param.props.on_click(this_as_param.props.resources[i],e)}} 
                        src={this_as_param.get_src_from_resource(this_as_param.props.resources[i])} 
                        style={{'userDrag':'none','border':'none','maxHeight': '100%', 'maxWidth' : '100%',display: this_as_param.props.noCache ? 'block' : 'none',borderRadius:'6px'}} 
                        draggable="true"
                        crossOrigin="anonymous"
                    />
                    </div>
                    {this_as_param.props.noCache && (<h6><b>{this_as_param.props.resources[i].name}</b></h6>)}
                </li>
                
            )
        }

        for (let i = 0; i < (this.props.resources ? this.props.resources.length: 0); i++) {
            var resource = this.props.resources[i];
            var aspect_ratio = 1;

            if(resource.width && resource.height) {
                aspect_ratio = resource.height / resource.width; 
            }else if (resource.design_file && resource.design_file.width && resource.design_file.height) {
                aspect_ratio = resource.design_file.height / resource.design_file.width; 
            }

            var height = 'calc(' + this.props.image_height + ' * ' + aspect_ratio + ')';

            var resource_thumbnail = resource_generate_temp(i,this,height);
            results_card.push(resource_thumbnail)
        }
        return results_card;
    }
    

    render() {
        if (this.props.resources.length == 0) {
            return <div></div>
        }
        return (
                <Masonry
                    className={'design-resources-gallery'}
                    elementType={'ul'} 
                    options={masonryOptions}
                    disableImagesLoaded={false} 
                    updateOnEachImageLoad={false}
                >
                   {<this.DesignResourceThumbnails/>}
                </Masonry>
        )
    }
}

export default DesignResourcesPanel;